<template>
  <VModalWidget :dismiss="dismiss" content-class="pa-0" small no-separator>
    <template slot="title">{{ $t(this.title) }}</template>

    <template slot="content">
      <croppa
        v-model="image"
        :width="$app.opts.modalSizeSmall"
        :height="$app.opts.modalSizeSmall"
        :placeholder="$t('choose')"
        :placeholder-font-size="0"
        :disabled="false"
        :prevent-white-space="false"
        :show-remove-button="false"
        :initial-image="previous"
        @file-choose="handleCroppaFileChoose"
        @file-size-exceed="handleCroppaFileSizeExceed"
        @file-type-mismatch="handleCroppaFileTypeMismatch"
        @image-remove="handleImageRemove"
        @move="handleCroppaMove"
        @zoom="handleCroppaZoom"
      />
    </template>

    <template slot="footer-actions">
      <v-btn text block @click="image.remove()">{{ $t('clear') }}</v-btn>
      <v-btn text block @click="image.rotate()">{{ $t('rotate') }}</v-btn>
      <v-btn text block @click="image.flipX()">{{ $t('flip') }}</v-btn>
      <v-btn depressed block color="default" @click="sendAvatar">{{ $t('save') }}</v-btn>
    </template>
  </VModalWidget>
</template>

<script>
import { VModalWidget } from '@argon/app/components'
const MIMETYPE = 'image/png'
const COMPRESSION = '1'

export default {
  name: 'AvatarModal',
  data: () => ({
    image: null
  }),
  components: {
    VModalWidget
  },
  props: {
    title: String,
    previous: String,
    dismiss: Function,
    uploadAvatar: { type: Function, required: true }
  },
  methods: {
    sendAvatar() {
      this.image.generateBlob(
        (blob) => {
          let data = new FormData()
          data.append('file', blob)
          this.uploadAvatar(data)
        },
        MIMETYPE,
        COMPRESSION
      )
    },
    handleCroppaFileChoose() {},
    handleCroppaFileSizeExceed() {},
    handleCroppaFileTypeMismatch() {},
    handleImageRemove() {},
    handleCroppaMove() {},
    handleCroppaZoom() {}
  }
}
</script>

<i18n>
{
  "en": {
    "choose": "Choose an image",
    "clear": "Clear",
    "flip": "Flip",
    "rotate": "Rotate",
    "save": "@:labels.save"
  },
  "fr": {
    "choose": "Choisissez une image",
    "clear": "Vider",
    "flip": "Renverser",
    "rotate": "Tourner",
    "save": "@:labels.save"
  }
}
</i18n>
